import { render } from "./PlantNotificationParks.vue?vue&type=template&id=037b6558&scoped=true"
import script from "./PlantNotificationParks.vue?vue&type=script&lang=js"
export * from "./PlantNotificationParks.vue?vue&type=script&lang=js"

import "./PlantNotificationParks.vue?vue&type=style&index=0&id=037b6558&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-037b6558"]])

export default __exports__